export default "__VITE_ASSET__CiaYa8sX__"